import React from 'react';
import styled from 'styled-components';

import Picture1 from '../../../../containers/assets/instructor-onboarding-image2.png';
import Picture2 from '../../../../containers/assets/instructor-onboarding-image3.png';
import Picture3 from '../../../../containers/assets/instructor-onboarding-image4.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;
  }
`;

const Images = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-top: 12px;
`;

const WelcomeStep2 = () => (
  <Wrapper>
    <Container>
      <Text1>Welcome</Text1>
      <Text2>The Intro to Business Game!</Text2>
      <Text3>
        In this fun yet challenging business game, your students will work in <b>teams</b>,
        play the <b>role of a manager</b>, and make <b>business decisions</b> with uncertain
        outcomes. They are expected to have very little business knowledge and the challenge
        for them is to get comfortable with the uncomfortable.
      </Text3>

      <Images>
        <img src={Picture1} alt="" />
        <img src={Picture2} alt="" />
        <img src={Picture3} alt="" />
      </Images>
    </Container>
  </Wrapper>
);

export default WelcomeStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/welcome/step2.js